import angular from 'angular';
import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.arrow', [])
	.directive('cianUiArrow', () => ({
		scope: {},
		bindToController: {
			rotate: '='
		},
		controller() {
		},
		controllerAs: 'arrow',
		replace: true,
		template
	}))
	.name;
